import { useIntl } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import { TERMS_INTRO, TERMS_SECTIONS, EXHIBIT_A_HEADING, EXHIBIT_A_CONTENT, TERMS_LAST_UPDATED } from '../../wwex-terms-content';

import { messages } from './messages';
import styles from './wwex-terms-display.module.less';

export const WwexTermsDisplay = () => {
  const intl = useIntl();

  return (
    <FlexColumn gap={Gap.Space20} className={styles.scrollContainer} ariaLabel={intl.formatMessage(messages.termsScrollRegionAriaLabel)}>
      <Text textType={TextType.Paragraph} value={TERMS_INTRO} />

      <FlexColumn gap={Gap.Space16}>
        {TERMS_SECTIONS.map((section, index) => (
          <FlexColumn key={index} gap={Gap.Space8}>
            <Text textType={TextType.H4} value={`${index + 1}. ${section.heading}`} />
            <Text textType={TextType.Paragraph} value={section.content} />
          </FlexColumn>
        ))}
      </FlexColumn>

      <FlexColumn gap={Gap.Space8} className={styles.exhibitSection}>
        <Text textType={TextType.H4} value={EXHIBIT_A_HEADING} />
        <Text textType={TextType.Paragraph} value={EXHIBIT_A_CONTENT} />
      </FlexColumn>

      <Text textType={TextType.Caption} value={TERMS_LAST_UPDATED} className={styles.lastUpdated} />
    </FlexColumn>
  );
};
